import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../Views/Home";
import LandingPage from "../Views/LandingPage";
import { Success } from "../Views/Success";
import { Failed } from "../Views/Failed";
import { Exibition } from "../Views/Exibition";
import ResultUapply from "../Views/ResultUapply";
import ResultIelts from "../Views/ResultIelts";
import Loader from "../Component/Loader/Loader";
import ScrollToTop from "../Component/ScrollToTop";

// Lazy load heavy components
const CareerTest = React.lazy(() =>
  import("../Views/CareerTest").then((module) => ({
    default: module.CareerTest,
  })),
);
const MajorTest = React.lazy(() => import("../Views/MajorTest"));

// New landing page (Claude Design redesign) — replaces Home at "/".
// The old Home stays reachable at /old-home during the transition.
const Landing = React.lazy(() => import("../Views/Landing"));
const UniversitiesView = React.lazy(() => import("../Views/Pages/UniversitiesView"));
const TestsToolsView = React.lazy(() => import("../Views/Pages/TestsToolsView"));
const SuccessStoriesView = React.lazy(() => import("../Views/Pages/SuccessStoriesView"));
const WhoWeAreView = React.lazy(() => import("../Views/Pages/WhoWeAreView"));
const EventsView = React.lazy(() => import("../Views/Pages/EventsView"));
const TermsView = React.lazy(() =>
  import("../Views/Pages/LegalView").then((m) => ({ default: m.TermsView })),
);
const PrivacyView = React.lazy(() =>
  import("../Views/Pages/LegalView").then((m) => ({ default: m.PrivacyView })),
);

// Tests hub / paid-ads landing page
const TestsHub = React.lazy(() => import("../Views/TestsHub"));
const Profile = React.lazy(() => import("../Views/Pages/ProfileView"));

// Hub pages (sidebar): favorites, device activity, progress, unified results
const Favorites = React.lazy(() => import("../Views/Favorites"));
const SessionHistory = React.lazy(() => import("../Views/SessionHistory"));
const MyProgress = React.lazy(() => import("../Views/MyProgress"));
const MyResults = React.lazy(() => import("../Views/MyResults"));

const AptitudeTest = React.lazy(() => import("../Views/AptitudeTest"));
const AptitudeResults = React.lazy(() => import("../Views/AptitudeResults"));
const Apply = React.lazy(() => import("../Views/ApplyLanding"));
const MoheScholarship = React.lazy(() => import("../Views/MoheScholarship"));
const UkCost = React.lazy(() => import("../Views/UkCostCalculator"));
const UniMatch = React.lazy(() => import("../Views/UniMatchView"));
const FindAccommodation = React.lazy(() => import("../Views/FindAccommodation"));
const ApplySuccess = React.lazy(() => import("../Views/Pages/SuccessView"));
const Result = React.lazy(() => import("../Views/Result"));
const IeltsRegistration = React.lazy(() =>
  import("../Views/IeltsRegistration").then((module) => ({
    default: module.IeltsRegistration,
  })),
);

const MathTestPage = React.lazy(() => import("../Views/MathTestPage"));
const MathTestDemo = React.lazy(() => import("../Views/MathTestDemo"));
const MathQuestionTest = React.lazy(
  () => import("../Component/MathQuestion/MathQuestionTest"),
);
const QuestionDebugPage = React.lazy(
  () => import("../Views/QuestionDebugPage"),
);

// IELTS Test Components
const IELTSLandingPage = React.lazy(
  () => import("../Component/IELTS/IELTSLandingPage"),
);
const IELTSTest = React.lazy(() => import("../Views/IELTSTest"));
const IELTSResults = React.lazy(() => import("../Views/IELTSResults"));

export default function AppRouter() {
  return (
    <Suspense
      fallback={
        <div>
          <Loader />
        </div>
      }
    >
      {/* reset scroll on every route change — without this, mobile users who
          scrolled the tests hub landed on the next page at the bottom */}
      <ScrollToTop />
      <Routes>
        <Route path="/tests" element={<TestsHub />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/favorites" element={<Favorites />} />
        <Route path="/history" element={<SessionHistory />} />
        <Route path="/progress" element={<MyProgress />} />
        <Route path="/results" element={<MyResults />} />
        <Route path="/aptitude-test" element={<LandingPage />} />
        <Route path="/" element={<Landing />} />
        <Route path="/old-home" element={<Home />} />
        <Route path="/universities" element={<UniversitiesView />} />
        <Route path="/tests-and-tools" element={<TestsToolsView />} />
        <Route path="/success-stories" element={<SuccessStoriesView />} />
        <Route path="/who-we-are" element={<WhoWeAreView />} />
        <Route path="/events" element={<EventsView />} />
        <Route path="/terms" element={<TermsView />} />
        <Route path="/privacy" element={<PrivacyView />} />
        <Route
          exact
          path={"/apply/exhibition-july2026"}
          element={<Exibition />}
        />
        <Route path="/career" element={<CareerTest />} />
        <Route path="/major-test" element={<MajorTest />} />
        <Route path="/aptitude-test-quiz" element={<AptitudeTest />} />
        <Route path="/aptitude-results" element={<AptitudeResults />} />
        <Route path="/math-test" element={<MathTestPage />} />
        <Route path="/math-demo" element={<MathTestDemo />} />
        <Route path="/math-question-test" element={<MathQuestionTest />} />
        <Route path="/question-debug" element={<QuestionDebugPage />} />

        {/* IELTS Test Routes */}
        <Route path="/ielts" element={<IELTSLandingPage />} />
        <Route path="/ielts-test" element={<IELTSTest />} />
        <Route path="/ielts-results" element={<IELTSResults />} />

        <Route path="/ielts-registration" element={<IeltsRegistration />} />
        <Route
          path="/ar/success-ielts-registration"
          element={<ResultIelts />}
        />
        <Route path="/apply" element={<Apply />} />
        <Route path="/mohe-scholarship" element={<MoheScholarship />} />
        <Route path="/uk-cost" element={<UkCost />} />
        <Route path="/uni-match" element={<UniMatch />} />
        <Route path="/find-accommodation" element={<FindAccommodation />} />
        <Route path="/test-results" element={<Result />} />
        <Route path="/ar/success" element={<ApplySuccess />} />
        <Route path="/kw/booking/success" element={<Success />} />
        <Route path="/booking/failed" element={<Failed />} />
      </Routes>
    </Suspense>
  );
}
